import Vue from 'vue'
import store from '@/store/'
import { ValuationStepData } from '@/interfaces/valuation/ValuationData'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import {
  BuildingStatus,
  BuildingType,
  BuildingAge,
  BuildingReconstruction,
} from '@/interfaces/valuation/types/BuildingValuationStep'
import { LocationType } from '@/interfaces/valuation/types/LocalityValuationStep'
import {
  ApartmentType,
  ApartmentFloor,
  ApartmentHeating,
  HouseStatus,
  HouseLocation,
  HouseSpecification,
  HouseSize,
  HouseHeating,
  ApartmentReconstruction,
} from '@/interfaces/valuation/types/UnitValuationStep'
import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import { keys, getNestedValue } from '@/util/helpers'

export default Vue.extend({
  created(): void {
    const stepData = store.getters['valuationProcess/currentStepData']

    if (Object.keys(stepData).length) {
      for (const key of keys(this.stepData)) {
        // @ts-ignore
        this.stepData[key] = getNestedValue(stepData, [key])
      }
    } else {
      store.commit('valuationProcess/setCurrentStepData', this.stepData)
    }
  },
  data() {
    return {
      stepData: {},
      PropertyType,
      BuildingStatus,
      BuildingType,
      BuildingAge,
      BuildingReconstruction,
      LocationType,
      ApartmentType,
      ApartmentFloor,
      ApartmentHeating,
      HouseStatus,
      HouseLocation,
      HouseSpecification,
      HouseSize,
      HouseHeating,
      ApartmentReconstruction,
    }
  },
  computed: {
    propertyType(): PropertyType {
      return store.getters['valuationProcess/propertyType']
    },
    validator(): ValuationStepValidator {
      return this.$store.getters['valuationProcess/valuationData'].currentStep
        .validator
    },
  },
  watch: {
    stepData: {
      handler(val: ValuationStepData) {
        store.commit('valuationProcess/setCurrentStepData', val)
      },
      deep: true,
    },
  },
})
